//index Trains

// Exportando componentes desde el módulo de Hoteles
export { default as TrainsHomepage } from './Homepage';
export { default as TrainsResults } from './ResultsView';

// Si hay más cosas que exportar, como funciones helper, constantes, etc., las agregarías aquí.
